export enum AgruparRelatorio {
    MARCA = 'MARCA',
    ITEM = 'ITEM',
    GRUPO = 'GRUPO',
    SUBGRUPO = 'SUBGRUPO',
    VENDEDOR = 'VENDEDOR',
    CLIENTE = 'CLIENTE',
    FATURA = 'FATURA',
    SEM_AGRUPAR = 'SEM_AGRUPAR',
}